module.exports = __webpack_public_path__ + "static/media/bounty-header.df72c710.png";